import { useContext } from 'react'
import { AuthContext } from 'store/AuthContext'
import type { UsersRes } from 'features/users'
import { useQuery } from 'libs/query'
import { useAxiosPrivate } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchUsers = () => {
	const { auth } = useContext(AuthContext)
	const axiosPrivate = useAxiosPrivate()
	const query = getCurrentQuery()

	const {
		data: users,
		isPending: isUsersLoading,
		isSuccess: isUsersSuccess
	} = useQuery<UsersRes>({
		queryKey: queryKeys.users.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.users(query)),
		enabled: !!auth.accessToken
	})

	return {
		users,
		isUsersLoading,
		isUsersSuccess
	}
}
